export const environment = {
  production: false,
  apiUrl: "https://qa-ie-api.equinemedirecord.com/api/v1",
  socketUrl: "https://qa-ie-api.equinemedirecord.com",
  socketPort: ":6001",
  maxImgCount: 5,
  maxImgSize: "20971520", // in bytes
  defaultLanguage: "en",
  languages: [],
  country: "ireland",
  availableCountries: {
    ireland: "https://qa-ie-app.equinemedirecord.com",
    uk: "https://qa-uk-app.equinemedirecord.com",
    france: "https://qa-fr-app.equinemedirecord.com",
    usa: "https://qa-us-app.equinemedirecord.com",
    sa: "https://qa-sa-app.equinemedirecord.com",
    ma: "https://qa-ma-app.equinemedirecord.com",
    aus: "https://qa-rv-app.equinemedirecord.com"    
  },
  stripeKey: "pk_test_vea7lB9bGJtzitYix9QpqcJu",
  quick_treatment: false,
  currency: "EUR",
  showRegionsSelect: true, //only for USA
  ruleBookPdf: null,
  ruleBookKYPdf: null,
  ruleBookCAPdf: null,
  ruleBookBCPdf: null,
  ruleBookBCPdPopup: null,
  ruleBookBC2023Pdf: null,
  ruleBookBC2023PdfPopup: null,
  filterRegionForDrugs: false,
  showModalUnvaccinated: true,
  showInTheFoodChainToggle: true,
  dateFormat: "dd/MM/yyyy",
  disableTreatmentEditInstructorNotOwned: false, //If set to true instructor (trainer) can not edit treatments not created by him.
  currentCountry: "ie",
  vaccinationCountries: ["uk", "fr"],
  ruleBookPCPdf: "",
  ruleBookPCPopup: "",
  ruleBookPKPdf: "",
  ruleBookPKPdfPopup: "",
  vaccinationDocumentUrl: "",
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/environments/environment.ts